import { Create as CreateIcon, Delete as DeleteIcon } from "@mui/icons-material";
import { Box, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from "@mui/material";
import React from "react";
import CustomPagination from "../../../../../components/custom-pagination/CustomPagination";
import DeleteRegisterRecordConformation from "../../../../../components/delete-register-record-conformation/DeleteRegisterRecordConformation";
import { AppMisc } from "../../../../../misc/appMisc";
import { AppUtils } from "../../../../../utils/appUtils";
import { NO_RECORDS_FOUND } from "../../../../../utils/constants";

export default function LabInfoRegister({ tableData, totalSize, onDeleteRow, onEditRow }) {

  return (
    <>
      <TableContainer classes={{ root: "fixed-head-table-container" }}  >
        <Table classes={{ root: "table-bordered normal-spacing" }} size="small" aria-label="lab Register">
          <TableHead classes={{ root: "align-center fixed-header header-sm" }}>
            <TableRow>
              <TableCell>क्र.सं.</TableCell>
              <TableCell>दर्ता मिति</TableCell>
              <TableCell>प्रयोगशाला दर्ता नं.</TableCell>
              <TableCell>नाम</TableCell>
              <TableCell>उमेर</TableCell>
              <TableCell>लिङ्ग</TableCell>
              <TableCell>सम्पर्क नं.</TableCell>
              <TableCell>सेवाहरू</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody classes={{ root: "align-center" }}>
            {tableData && tableData.length > 0 ? (
              tableData.map((row, index) => (
                <TableRow key={row.id}>
                  <TableCell>{AppUtils.replaceWithNepaliDigit(index + 1)}</TableCell>
                  <TableCell>{AppMisc.getDateLabelFromMillisecond(row.dartaaMiti)}</TableCell>
                  <TableCell>{AppUtils.replaceWithNepaliDigit(row.labNumber)}</TableCell>
                  <TableCell>  <a href={`lab-test-details?id=${row.id}`} variant="body2">
                    {row.patientFirstName} {row.patientLastName}
                  </a>
                  </TableCell>
                  <TableCell>{AppUtils.replaceWithNepaliDigit(row.age)}</TableCell>
                  <TableCell>{AppMisc.getGenderLabel(row.gender)}</TableCell>
                  <TableCell>{row.phoneNumber}</TableCell>
                  <TableCell>
                    {row.labSewa?.map(item => item.sewaName).join(", ")}
                  </TableCell>
                  <TableCell>
                    <Box display={"flex"} justifyContent={"space-around"}>
                      <Tooltip title="सम्पादन गर्नुहोस्">
                        <IconButton size="small" onClick={() => onEditRow(row.id)}>
                          <CreateIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="हटाउनुहोस्">
                        <IconButton size="small" onClick={() => onDeleteRow(row.id)}>
                          <DeleteIcon fontSize="small" color="secondary" />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  <Typography variant="body2">{NO_RECORDS_FOUND}</Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <CustomPagination
        count={totalSize}
      />
    </>
  );
}
